import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';
import style from './style.css';

@observer
class DragNDrop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dragging: false,
            draggable: -1,
            dragged: -1,
            over: -1,
        };
    }

    onMouseDown = (idx) => {
        this.setState({
            draggable: idx,
        });
    }

    onMouseUp = () => {
        this.setState({
            draggable: -1,
        });
    }

    dragStart = (idx, e) => {
        // const { items = [] } = this.props;
        if (e.target.getAttribute('draggable') === 'false') return;
        // e.dataTransfer.setData('application/json', JSON.stringify(items[idx]));
        e.dataTransfer.effectAllowed = 'move';

        this.setState({
            dragging: true,
            dragged: idx,
            over: idx,
        });
    }

    dragEnd = () => {
        this.setState({
            dragging: false,
            draggable: -1,
            dragged: -1,
            over: -1,
        });
    }

    dragOver = (idx, e) => {
        this.setState({
            over: idx,
        });

        if (idx === this.state.dragged) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
    }

    drop = (target) => {
        const { dragged } = this.state;
        if (dragged === target) return;
        const newItems = this.props.items.slice();
        newItems.splice(target, 0, newItems.splice(dragged, 1)[0]);
        this.props.onSort(newItems);
    }

    render({
        container: Container, item: Item, items = [], handle: Handle, prop, imagePrefix, handleDelImage, articleId,
    }, {
        dragged, dragging, over, draggable,
    }) {
        const newItems = dragging && over !== dragged ? items.slice() : items;

        if (dragging && over !== dragged) {
            newItems.splice(over, 0, newItems.splice(dragged, 1)[0]);
        }

        return (
            <Container aria-dropeffect='move'>
                {newItems.map((data, idx) => (
                    <Item
                        key={data[prop]}
                        data={data}
                        handle={
                            <Handle
                                onMouseDown={() => this.onMouseDown(idx)}
                                onMouseUp={() => this.onMouseUp()}
                                data={data}
                            />
                        }
                        draggable={!Handle || draggable === idx}
                        beeingDragged={!Handle || draggable === idx}
                        over={dragging && idx === over}
                        onDragStart={e => this.dragStart(idx, e)}
                        onDragEnd={() => this.dragEnd(idx)}
                        onDragOver={e => this.dragOver(idx, e)}
                        onDrop={() => this.drop(idx)}
                        role='option'
                        aria-grabbed={dragging && idx === over}
                        grabbed={dragging && idx === over}
                        imagePrefix={imagePrefix}
                        articleId={articleId}
                        idx={idx}
                        handleDelImage={handleDelImage}
                    />
                ))}
            </Container>
        );
    }
}

const Item = ({ data, handle, beeingDragged, over, ...props }) => {
    return (
        <li class={`item ${beeingDragged ? style.dragged : ''} ${over ? style.over : ''}`} {...props}>
            {handle}
            <section class='content'>
                <p>Item #{data.id}</p>
                {JSON.stringify(props)}
            </section>
        </li>
    );
};

DragNDrop.defaultProps = {
    container: ({ children, ...props }) => <ul {...props}>{children}</ul>,
    item: Item,
    handle: ({ ...props }) => (
        <button class='btn btn-link' {...props}>
            <i class='fas fa-bars' />
        </button>
    ),
    onSort: () => {},
    onSwap: (from, to) => {},
    prop: 'id',
};

export default DragNDrop;



// WEBPACK FOOTER //
// ./components/form/dragNdrop.js